<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <persona-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import PersonaShowData from "./PersonaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "PersonaShow",
        components: {CrudShow, PersonaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.persona.showing',
            }
        },
    }
</script>

